<template>
  <div>
    404 page can not be found
  </div>
</template>

<script>
  export default {
    name: 'NotFound404Component',
  };
</script>

<style scoped>

</style>
